import { TypedDocumentNode, gql } from "@apollo/client";

import {
  GetGoogleMapsApiKeyQuery,
  GetGoogleMapsApiKeyQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { useFetchQuery } from "src/graphql/utils";

export const getGoogleMapsApiKeyQuery = gql(/* GraphQL */ `
  query GetGoogleMapsApiKey {
    googleMapsApiKey
  }
`) as TypedDocumentNode<GetGoogleMapsApiKeyQuery, GetGoogleMapsApiKeyQueryVariables>;

export const useGetGoogleMapsApiKeyQuery = () => {
  return useFetchQuery(getGoogleMapsApiKeyQuery, {
    isEmpty: (data) => !data?.googleMapsApiKey,
    toData: (data) => data?.googleMapsApiKey,
    uiErrors: {
      fetchError: "UNKNOWN-ERROR",
      emptyError: "UNKNOWN-ERROR",
    },
  });
};
